<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage Programmes</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="createProgramme()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                            <!-- <n-button
                                @click.native="openUploadModal()"
                                class="view ml-2"
                                type="warning"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-upload"></i>
                            </n-button> -->

                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <!-- <el-table-column type="expand">
                            <template slot-scope="props">
                                <div class="row">
                                    <div class="col-sm" v-for="(event, index) in props.row.events" :key="index">
                                        <n-button type="primary" plain @click.native="handleViewRegistrationsEvent(event)">{{ event }}</n-button>
                                    </div>
                                </div>
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="230" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <el-tooltip class="item" effect="dark" content="View Dashboard" placement="top">
                                    <n-button @click.native="handleViewDashboard(props.$index, props.row)" class="view" type="info" size="sm" round icon simple >
                                        <i class="fa fa-tachometer"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="View Registrations" placement="top">
                                    <n-button @click.native="handleViewRegistrations(props.$index, props.row)" class="view" type="success" size="sm" round icon simple >
                                        <i class="fa fa-users"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Preview" placement="top">
                                    <n-button @click.native="handleView(props.$index, props.row)" class="view" type="primary" size="sm" round icon simple >
                                        <i class="fa fa-eye"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                    <n-button @click.native="handleEdit(props.$index, props.row)" class="edit" type="warning" size="sm" round icon simple >
                                        <i class="fa fa-pencil"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                                    <n-button @click.native="handleDelete(props.$index, props.row)" class="remove" type="danger" size="sm" round icon simple>
                                        <i class="fa fa-times"></i>
                                    </n-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Upload, Progress } from "element-ui";
import { Pagination as NPagination, Modal } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Upload.name]: Upload,
        [Progress.name]: Progress,
        Modal
    },
    computed: {
        ...mapGetters({
            tableData: 'getProgrammes',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "title", "events" ],
            tableColumns: [
                {
                    prop: "slug",
                    label: "Slug",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "register_no",
                    label: "Reg #",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: true,
                    hidden: true,
                },
                {
                    prop: "title",
                    label: "Title",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                },
                {
                    prop: "department",
                    label: "Department",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "events",
                    label: "Events",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? cellValue.join(', ').trim(', ').replace('-',' ') : '--'; 
                    }
                },
                {
                    prop: "eventType",
                    label: "Type",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "login",
                    label: "Login",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? 'Yes' : 'No'; 
                    }
                },
                {
                    prop: "visible",
                    label: "Visible",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? 'Yes' : 'No'; 
                    }
                },
                {
                    prop: "events",
                    label: "# Events",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? cellValue.length : 0; 
                    }
                },
                {
                    prop: "seating.current_seat",
                    label: "Booked #",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false
                },
                {
                    prop: "seating.max_seat",
                    label: "Seats #",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false
                },
                {
                    prop: "permitted_enrollments",
                    label: "P.Enroll",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false
                },
                {
                    prop: "price",
                    label: "Price",
                    minWidth: 150,
                    align: 'right',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? `Rs. ${cellValue}` : `--`; 
                    }
                },
                {
                    prop: "open_date",
                    label: "Open Date",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                {
                    prop: "close_date",
                    label: "Close Date",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                {
                    prop: "start_date",
                    label: "Event Start",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                {
                    prop: "end_date",
                    label: "Event End",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false,
                upload: false
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        handleViewDashboard(index, row) {
            this.$router.push(`/programmes/dashboard/${row.slug}`)
        },
        handleViewRegistrations(index, row) {
            this.$router.push(`/registrations/view/programme/${row.slug}`)
        },
        handleViewRegistrationsEvent(slug) {
            this.$router.push(`/registrations/view/event/${slug}`)
        },
        handleView(index, row) {
            this.$router.push(`/programmes/view/${row.slug}`)
        },
        handleEdit(index, row) {
            this.$router.push(`/programmes/edit/${row.slug}`)
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        
        deleteRow(row) {
            this.$store.dispatch('deleteProgramme', row.slug)
        },
        createProgramme(){
            this.$router.push('/programmes/create')
        },
    },
    mounted() {
        // Fuse search initialization.
        // this.fuseSearch = new Fuse(this.tableData, {
        //     keys: this.propsToSearch,
        //     threshold: 0.0,
        //     minMatchCharLength: 3
        // });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getProgrammes');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                // let result = Object.assign([], this.tableData);
                // if (value !== "") {
                //     result = this.fuseSearch.search(value);
                //     console.log(result);
                // }
                // this.searchedData = result;
                // this.searchedData = this.tableData
                if (value !== "") {
                    value = value.toLowerCase();
                    this.searchedData = this.tableData.filter(item => {
                        if(item.title.toLowerCase().search(value) >= 0){
                            return true
                        }

                        if(item.events.join(', ').trim(', ').replace('-',' ').toLowerCase().search(value) >= 0){
                            return true
                        }

                        return false
                    })
                }
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                // this.fuseSearch = new Fuse(this.tableData, {
                //     keys: this.propsToSearch,
                //     threshold: 0.0,
                //     minMatchCharLength: 3
                // })
                // let result = Object.assign([], this.tableData);
                // if (this.searchQuery !== "") {
                //     result = this.fuseSearch.search(this.searchQuery);
                // }
                // this.searchedData = result;
                this.searchedData = Object.assign([], value)
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-file{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip em {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }
</style>

